import 'unfetch/polyfill';

import React from 'react';
import { hydrate } from 'react-dom';
import BrowserRouter from '@empiriecom/module-components/BrowserRouter';
import App from '../components/App';

const namespace = process.env.FRAGMENT_NAMESPACE || 'og-emma';
const rootElem = window.document.getElementById(namespace);
const isDisableLegacy = rootElem?.dataset?.disableLegacy === 'true';

hydrate(
  <BrowserRouter>
    <App disableLegacy={isDisableLegacy} />
  </BrowserRouter>,
  document.getElementById(namespace),
);

if (module.hot) {
  module.hot.accept();
}
